import { z } from "zod";
import { idString } from "./common.js";
/** KPI Watchlist — up to six KPIs referenced by id (resolved by the mock). */
export const KpiWatchlistParamsSchema = z
    .object({
    kpiIds: z.array(idString).max(6),
})
    .strict();
export const defaultKpiWatchlistParams = { kpiIds: [] };
//# sourceMappingURL=kpiWatchlist.js.map